import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

import { ReactComponent as ClearIcon } from '../../../../../../_base/layout/assets/layout-svg-icons/clear.svg';

const FilterField = styled(TextField)(() => ({
  width: '100%',

  '& .MuiOutlinedInput-root': {
    height: 44,
    background: '#ffff',
    borderRadius: 22,
    paddingRight: 6,
    fontSize: 17,
    fontWeight: 600,
    color: '#181c32',

    // '& fieldset': {
    //   border: 'none',
    // },

    // '&:hover fieldset': {
    //   border: 'none',
    // },

    // '&.Mui-focused fieldset': {
    //   border: 'none',
    // },
  },

  '& .MuiOutlinedInput-input': {
    padding: '0 18px',
  },

  '& input::placeholder': {
    color: '#7B7F8A',
    opacity: 1,
    fontWeight: 400,
  },
}));

const CircleButton = styled(IconButton)(() => ({
  padding: 0,
}));

export const ManufacturersSearchField = ({
  handleSearch,
  search,
}: {
  handleSearch: (value?: string) => void;
  search?: string;
}) => {
  const [searchText, setSearchText] = React.useState(search || '');
  return (
    <Box
      display='flex'
      gap='12px'
      flexDirection='row'
      alignItems='center'
      sx={{
        width: '100%',
      }}
    >
      <FilterField
        placeholder='Поиск'
        variant='outlined'
        value={searchText}
        onChange={e => setSearchText(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch(searchText);
          }
        }}
        InputProps={{
          endAdornment: searchText ? (
            <InputAdornment position='end'>
              <CircleButton
                onClick={() => {
                  setSearchText('');
                  handleSearch('');
                }}
              >
                <ClearIcon />
              </CircleButton>
            </InputAdornment>
          ) : null,
        }}
      />

      <Button color='primary' variant='contained' onClick={() => handleSearch(searchText)}>
        Найти
      </Button>
    </Box>
  );
};
